import { render } from "./KanbanView.vue?vue&type=template&id=2b7c578c"
import script from "./KanbanView.vue?vue&type=script&lang=js"
export * from "./KanbanView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__